import React from "react";
import { Modal, Descriptions, Divider, Button } from "antd";
import { PictureOutlined, PlayCircleOutlined } from "@ant-design/icons";
import "./viewHomeBanner.css";

const HomeBannerViewModal = ({ visible, bannerData, onClose }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "Not specified";
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <Modal
      title={
        <div className="view-hb-modal-header-content">
          <PictureOutlined className="view-hb-modal-header-icon" style={{ color: "white" }} />
          <span style={{ color: "white" }}>BANNER DETAILS</span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={800}
      className="view-hb-modal-override"
      styles={{
        header: {
          background: "#070C18",
          borderRadius: "12px 12px 0 0",
          padding: "20px 24px",
          borderBottom: "none",
        },
        body: {
          padding: "24px",
          background: "#fafafa",
        },
      }}
    >
      <div className="view-hb-modal-content">

        {/* Basic Info */}
        <div className="view-hb-card">
          <h3 className="view-hb-card-header">Banner Information</h3>
          <div className="view-hb-grid">
            <Descriptions column={2} bordered size="small">
              <Descriptions.Item label="Type">
                <span className="view-hb-value view-hb-type-badge">
                  {bannerData?.type || "N/A"}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label="Created">
                {formatDate(bannerData?.created_at)}
              </Descriptions.Item>
              <Descriptions.Item label="Updated">
                {formatDate(bannerData?.updated_at)}
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                <span className={`view-hb-status ${bannerData?.is_deleted ? "view-hb-status-deleted" : "view-hb-status-active"}`}>
                  {bannerData?.is_deleted ? "Deleted" : "Active"}
                </span>
              </Descriptions.Item>
            </Descriptions>
          </div>
        </div>

        <Divider className="view-hb-divider" />

        {/* Banner Image */}
        <div className="view-hb-card">
          <h3 className="view-hb-card-header">Banner Image</h3>
          <div className="view-hb-image-container">
            {bannerData?.home_image ? (
              <img
                src={bannerData.home_image}
                alt="Banner"
                className="view-hb-image"
              />
            ) : (
              <div className="view-hb-no-image">
                <PictureOutlined style={{ fontSize: 48, color: "#ccc" }} />
                <p>No image available</p>
              </div>
            )}
          </div>
        </div>

        {/* Video — only if exists */}
        {bannerData?.home_videos && (
          <>
            <Divider className="view-hb-divider" />
            <div className="view-hb-card">
              <h3 className="view-hb-card-header">Banner Video</h3>
              <div className="view-hb-video-container">
                <PlayCircleOutlined className="view-hb-video-icon" />
                <a
                  href={bannerData.home_videos}
                  target="_blank"
                  rel="noreferrer"
                  className="view-hb-video-link"
                >
                  {bannerData.home_videos}
                </a>
              </div>
            </div>
          </>
        )}

        <Divider className="view-hb-divider" />

        {/* Actions */}
        <div className="view-hb-actions">
          <Button
            size="large"
            onClick={onClose}
            style={{ background: "#070C18"}}
            className="view-hb-btn view-hb-btn-primary"
          >
            Close
          </Button>
        </div>

      </div>
    </Modal>
  );
};

export default HomeBannerViewModal;